import useSWRMutation from 'swr/mutation';
import capsFetcher from '../../shared/capsFetcher';
import useRepair from '../read';

const repairUpdateFetcher = async (url, { arg: data }) => {
  const res = await capsFetcher({
    method: 'PUT',
    url,
    data,
  });
  return res.data;
};

const useRepairUpdate = (options) => {
  const { data: repair } = useRepair();
  return useSWRMutation(
    `/repairs/${repair.id}`,
    repairUpdateFetcher,
    { populateCache: true, revalidate: false, ...options },
  );
};

export default useRepairUpdate;
